<template>
  <v-layout>
    <v-flex>
      <panel title="Group Information">
        <v-text-field
          :rules="[required]"
          v-model="group.name"
          label="Name"
          required
        />
        <v-text-field
          v-model="group.contactName"
          label="Contact Name"
        />
        <v-text-field
          v-model="group.phone"
          label="Phone"
        />
        <v-text-field
          v-model="group.email"
          label="Email"
        />
        <v-text-field
          v-model="group.addr"
          label="Address"
        />
         <v-text-field
          v-model="group.notes"
          label="Notes"
        />
  <!-- <div class="container">
    <div class="large-12 medium-12 small-12 cell">
      <label>File Preview
        <input 
          id="file" 
          ref="file" 
          type="file" 
          accept="image/*" 
          @change="handleFileUpload()">
      </label>
      <img 
        v-show="showPreview"
        :src="imagePreview" 
        >
    </div> 
  </div> -->
    <v-layout row>
     <v-flex>
      <v-btn
        :color="strongColor" 
        :to="{
          name: 'groups'
        }"
         dark> 
        Return to Groups Page
      </v-btn>
    </v-flex>
    <v-spacer/>
     <v-flex 
        v-if="newGroupId === null">
        <v-btn
        :color="strongColor"
        dark
        @click="createGroup"  
        >
          Create Group
        </v-btn>
     </v-flex>
     <v-flex v-else>
      <v-btn
        :color="strongColor"
        dark
        @click="saveGroup">
        Update Group
      </v-btn>  
     </v-flex>
    </v-layout>
    </panel>
  </v-flex>
  <div
    v-if="error"
    class="danger-alert"
  >
    {{ error }}
  </div>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex'
import GroupsService from '@/services/GroupsService'
import { STRONG_COLOR } from '@/components/globals/consts'
//import EventBus from '@/main'

export default {
	data () {
		return {
			group: {
				name: null, // group name
				contactName: null,
				addr: null,
				phone: null,
				email: null,
        image: null,
        notes: null,
        UserId: this.$store.state.user.id,
        testType: this.$store.state.testType
      },
      file: null,
      showPreview: false,
      imagePreview: null,
      newGroupId: null,
      
      error: null,
      strongColor: STRONG_COLOR,
      required: (value) => !!value || 'Required.',
      
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
      'route',
      'testType',
      'currentGroupClients',
      'groupId'
		])
  },
	methods: {
    removeImage: function (e) {
      this.selectedFile = null
    },

  async handleFileUpload () {
    /*
      Set the local file variable to what the user has selected.
    */
    this.file = this.$refs.file.files[0];
    /*
      Initialize a File Reader object
    */
    let reader  = new FileReader();
    /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
    */
    await reader.addEventListener("load", function () {
      this.showPreview = true;
      this.imagePreview = reader.result;
    }.bind(this), false);

    /*
      Check to see if the file is not empty.
    */
    if( this.file ){
      /*
        Ensure the file is an image file.
      */
      if ( /\.(jpe?g|png|gif)$/i.test( this.file.name ) ) {
        /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
        */
        await reader.readAsDataURL( this.file )
        this.group.image = this.file
      }
    }
  },
		async saveGroup (req, res) {
			this.error = null
      const groupId = this.groupId
			try {
        await GroupsService.put(this.group)
			} catch (err) {
				console.log(err)
			}
		},
		async createGroup () {
        try {
          const groupId = (await GroupsService.post(this.group)).data.id
          this.newGroupId = groupId
          await this.$store.dispatch("setGroupName", null);
          await this.$store.dispatch("setCurrentGroupClients", []);
          await this.$store.dispatch("setGroupId", groupId);
          await this.$store.dispatch("setClientsToRemoveFromGroup", null);

          await this.$router.push({
          name: 'group-edit-clients',
          params: {
              groupId: groupId
            }
           })
        } catch (e) {
          console.log(e)
        }
    }
	}
}
</script>

<style scoped>
  div.container img{
    max-width: 200px;
    max-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateGroup/CreateGroup.vue